import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle } from 'lucide-react';
export function ResultsSection() {
  const results = ['Despertar con menos rigidez en las primeras horas de la mañana', 'Subir escaleras con más confianza y menos crujidos', 'Entender exactamente qué está causando tu dolor articular', 'Saber qué alimentos están alimentando tu inflamación sin que lo sepas', 'Tener un protocolo permanente que puedes seguir de por vida sin costo', 'Ahorrar entre $200 y $400 dólares al mes en suplementos que no necesitas', 'Recuperar la confianza en tu propio cuerpo y en su capacidad de sanar'];
  return <section className="bg-gold-light py-20 px-6 md:px-12 lg:px-24" data-id="element-226">
      <div className="max-w-4xl mx-auto" data-id="element-227">
        <FadeIn data-id="element-228">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-dark-green mb-12" data-id="element-229">
            Después de los 7 días vas a:
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-230">
          {results.map((result, index) => <FadeIn key={index} delay={index * 0.1} className={index === results.length - 1 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''} data-id="element-231">
              <div className="flex items-start gap-4 bg-white p-6 rounded-xl shadow-sm h-full border border-gold/20" data-id="element-232">
                <CheckCircle className="text-sage flex-shrink-0 mt-1" size={24} data-id="element-233" />
                <p className="text-lg text-text-black font-medium" data-id="element-234">{result}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}